import _ from 'lodash';

import { getLatestConversationId } from 'actions/conversation/lib/conversation_helpers';
import ServerClock from 'scripts/application/lib/server_clock';
import UpdateAgentRead from 'actions/conversation/update_agent_read';

// When an agent leaves a customer having seen every item from someone else, marks the customer's latest conversation
// read up to now. Its updatedAt also moves for changes that aren't feed items, and the inbox shows it unread until
// readTo passes that. If items from others are still unseen, readTo stays at the latest item seen so they show as new
// next time.
export default class MarkConversationReadOnLeave {
  constructor(context) {
    this.context = context;
  }

  run({ customerId, hasUnseenItems }) {
    // The feed also unmounts when it reloads for the same customer, e.g. after a conversation merge.
    const isStillOnCustomer = _.get(this.context.stores.currentLocation.get(), 'customerId') === customerId;
    if (hasUnseenItems || isStillOnCustomer || !this.context.stores.customers.has({ id: customerId })) {
      return;
    }

    const conversationId = getLatestConversationId(this.context.stores.customers.storesFor(customerId).conversations);
    if (!conversationId) {
      return;
    }

    this.context.executeAction(UpdateAgentRead, {
      agentReadAttrs: { readTo: ServerClock.toISOString() },
      conversationId,
      customerId,
    });
  }
}
